import React, { FC, useEffect, useState } from "react";
import StayCard from "components/StayCard/StayCard";
import {HotelType } from "data/types";
import Pagination from "shared/Pagination/Pagination";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import { filterArray } from "utils/filtersUtils";


export interface SectionGridFilterCardProps {
  className?: string;
  data?: HotelType[];
}

const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  data = [],
}) => {
  const [priceFilter,setPriceFilter] = useState([0,1200])
  const [filterData,setFilterData] = useState(data)
  const [beds,setBeds] = useState<any>()
  const [bedrooms,setBedrooms] = useState<any>()
  const [bathds,setBaths] = useState<any>()


  //Pagination
  const dataLimit = 4;
  const [pages] = React.useState(Math.round(data.length / dataLimit));
  const [currentPage, setCurrentPage] = React.useState(1);

  function changePage(event: React.MouseEvent<HTMLButtonElement>) {
    const pageNumber = Number(event.currentTarget.textContent);
    setCurrentPage(pageNumber);
  }

  const getPaginatedData = () => {
    const startIndex = currentPage * dataLimit - dataLimit;
    const endIndex = startIndex + dataLimit;
    return filterData.slice(startIndex, endIndex);
  };

  
    useEffect(()=>{

      const hotelFilters = {
        daily_room_price: (daily_room_price: number) => daily_room_price >= priceFilter[0] && daily_room_price <= priceFilter[1],
      }

      const filtered = filterArray(data,hotelFilters)
      setFilterData(filtered)
      
    },[priceFilter])

    useEffect(() => {
      setFilterData(data)
    },[data])

  return (
    <div
      id="nc-SectionGridFilterCard"
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <Heading2 heading="Recommeded Hotel rooms " subHeading="Filter results to find your perfect hotel room" />

      <div className="mb-8 lg:mb-11">
        {<TabFilters handlePrice={(value)=>setPriceFilter(value)} handleBathrooms={(value)=>setBaths(value)} handleBeds={(value)=>setBeds(value)} handleRooms={(value)=>setBedrooms(value)} />}
      </div>
      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {getPaginatedData().map((stay) => (
          <StayCard key={stay.id} data={stay}  />
        ))}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <Pagination
          pages={pages}
          currentPage={currentPage}
          changePage={changePage}
         />
      </div>
    </div>
  );
};

export default SectionGridFilterCard;
